import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { Box, Grid } from '@dhl-ui/components'
import { links } from '~/AppRoutes'
import { AccountDataTable } from '~/common/components/accountnumbers'
import { useNavigateWithSearchString, useSearchQuery } from '~/common/hooks'
import { isCccBusinessUnit } from '~/common/model/businessunits'

import {
  IntegratorsCard,
  OrganisationAddressesCard,
  OrganisationDetails,
  OrganisationsAccountManagersCard,
  UsersCard,
} from '~/modules/organisations/components'
import { useOrganisation } from '~/modules/organisations/hooks'
import { BackButton } from '~/temp-ds-component/BackButton'

type Params = {
  id: string
}

export const OrganisationDetailsPage = () => {
  const navigate = useNavigate()
  const { id } = useParams<Params>()
  const labelRequestPid = useSearchQuery('labelPid')
  const billingUnitId = useSearchQuery('billingunit')
  const isFromLabelRequest = !!labelRequestPid
  const isFromBillingUnit = !!billingUnitId

  const navigateWithSearchString = useNavigateWithSearchString(true)
  const { t } = useTranslation()

  const { organisation } = useOrganisation(id)

  const onBack = () => {
    isFromLabelRequest
      ? navigate({ pathname: links.labelLink(), search: `?labelPid=${labelRequestPid}` })
      : isFromBillingUnit
        ? navigate(`/billingunits/details/${billingUnitId}`)
        : navigateWithSearchString(links.organisationsLink())
  }

  return organisation && id ? (
    <>
      <Box marginBottom={2}>
        <BackButton onClick={onBack}>
          {t(
            isFromLabelRequest
              ? 'admin.organisationsPage.organisationForm.backButtonTitleLabel'
              : 'admin.organisationsPage.organisationForm.backButtonTitle'
          )}
        </BackButton>
      </Box>
      <Grid direction="row" container spacing={3}>
        <Grid size={{ md: 6, sm: 12 }}>
          <Box mb={2}>
            <OrganisationDetails organisation={organisation} />
          </Box>
          <Box mb={2}>
            <OrganisationsAccountManagersCard organisation={organisation} />
          </Box>
        </Grid>
        <Grid size={{ md: 6, sm: 12 }} display="flex" flexDirection="column" flexGrow={1}>
          <Box mb={2}>
            <UsersCard organisationId={id} />
          </Box>
          <AccountDataTable organisation={organisation} businessType={'organisation'} withAccountStatus />
          <Box my={2}>
            <OrganisationAddressesCard organisation={organisation} />
          </Box>
          {isCccBusinessUnit(organisation.businessUnitCode) && (
            <Box my={2}>
              <IntegratorsCard organisation={organisation} />
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  ) : null
}
